<template>
  <div class="d-flex flex-column pt-10">
    <h2 class="align-self-center mt-5">Step 1. Profile Data</h2>

    <v-form @submit.prevent="submit" class="d-flex flex-column" autocomplete="off" novalidate>
      <div class="d-flex flex-column mr-auto ml-12 py-10">
        <v-menu
          ref="menu"
          v-model="menu"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-on="on"
              class=" flex-grow-0"
              label="Date of Interview*"
              v-model="interviewDate"
              readonly
              :error-messages="interviewDateErrors"
            ></v-text-field>
          </template>
          <v-date-picker v-model="interviewDate" no-title color="primary"></v-date-picker>
        </v-menu>
        <v-text-field class=" flex-grow-" :error-messages="companyExists" label="Company code*" v-model="orgCode"></v-text-field>
         <v-text-field
            class="flex-grow-0"
            label="First Name*"
            :error-messages="firstNameErrors"
            v-model="firstName"
          ></v-text-field>
          <v-text-field
            class="flex-grow-0"
            label="Last name*"
            :error-messages="lastNameErrors"
            v-model="lastName"
          ></v-text-field>

           <v-text-field
            class="flex-grow-0"
            label="Passport No. / Government ID*"
            v-model="passportNo"
            :error-messages="passportNoErrors"
          ></v-text-field>

           <v-text-field
            class="flex-grow-0"
            label="Cellphone No. *"
            v-model="permanentAddress.cellPhoneNo"
            :error-messages="cellPhoneNoErrors"
          ></v-text-field>
          <v-text-field
            class="flex-grow-0"
            label="Email Address *"
            v-model="email"
            :error-messages="emailErrors"
          ></v-text-field>

          <v-text-field
            class="flex-grow-0"
            label="Full address *"
            v-model="fullAddress"
            :error-messages="fullAddressErrors"></v-text-field>

      </div>
      <div class="d-flex">
        <div class="d-flex flex-grow-1 flex-column px-10">
          <p class="font-weight-bold">1. Patient Profile</p>
         
          <v-text-field class="flex-grow-0" label="Middle Name" v-model="patientProfile.middleName"></v-text-field>
          <v-text-field class="flex-grow-0" label="BirthDay" v-model="patientProfile.birthDay"></v-text-field>
          <v-text-field class="flex-grow-0" label="Age" v-model="patientProfile.age"></v-text-field>
          <v-text-field class="flex-grow-0" label="Sex" v-model="patientProfile.sex"></v-text-field>
          <v-text-field class="flex-grow-0" label="Occupation" v-model="patientProfile.occupation"></v-text-field>
          <v-text-field
            class="flex-grow-0"
            label="Civil Status"
            v-model="patientProfile.civilStatus"
          ></v-text-field>
          <v-text-field
            class="flex-grow-0"
            label="Nationality"
            v-model="patientProfile.nationality"
          ></v-text-field>
         

          <p class="font-weight-bold">2. Phillipine Residence</p>
          <p class="font-weight-bold">2.1 Permanent Address</p>
          <v-text-field
            class="flex-grow-0"
            label="House No./Lot/Bldg"
            v-model="permanentAddress.houseNo"
          ></v-text-field>
          <v-text-field
            class="flex-grow-0"
            label="Street/Barangay"
            v-model="permanentAddress.street"
          ></v-text-field>
          <v-text-field
            class="flex-grow-0"
            label="Municipality"
            v-model="permanentAddress.municipality"
          ></v-text-field>
          <v-text-field class="flex-grow-0" label="City" v-model="permanentAddress.city"></v-text-field>
          <v-text-field class="flex-grow-0" label="Province" v-model="permanentAddress.province"></v-text-field>
          <v-text-field class="flex-grow-0" label="Region" v-model="permanentAddress.region"></v-text-field>
          <v-text-field
            class="flex-grow-0"
            label="Home Phone No."
            v-model="permanentAddress.homePhoneNo"
          ></v-text-field>
         
          <p class="font-weight-bold">2.2 Current Address</p>
          <v-text-field
            class="flex-grow-0"
            label="House No./Lot/Bldg"
            v-model="currentAddress.houseNo"
          ></v-text-field>
          <v-text-field class="flex-grow-0" label="Street/Barangay" v-model="currentAddress.street"></v-text-field>
          <v-text-field
            class="flex-grow-0"
            label="Municipality"
            v-model="currentAddress.municipality"
          ></v-text-field>
          <v-text-field class="flex-grow-0" label="City" v-model="currentAddress.city"></v-text-field>
          <v-text-field class="flex-grow-0" label="Province" v-model="currentAddress.province"></v-text-field>
          <v-text-field class="flex-grow-0" label="Region" v-model="currentAddress.region"></v-text-field>
          <v-text-field
            class="flex-grow-0"
            label="Home Phone No."
            v-model="currentAddress.homePhoneNo"
          ></v-text-field>
          <v-text-field
            class="flex-grow-0"
            label="Work Phone No."
            v-model="currentAddress.workPhoneNo"
          ></v-text-field>
          <v-text-field
            class="flex-grow-0"
            label="Other Email Address"
            v-model="currentAddress.otherEmail"
          ></v-text-field>
        </div>

        <div class="d-flex flex-grow-1 flex-column px-10">
          <p class="font-weight-bold">3. Address Outside the Philipines</p>

          <v-text-field
            class="flex-grow-0"
            label="Employer's Name"
            v-model="addressOutside.employersName"
          ></v-text-field>
          <v-text-field class="flex-grow-0" label="Occcupation" v-model="addressOutside.occupation"></v-text-field>
          <v-text-field
            class="flex-grow-0"
            label="Place of Work"
            v-model="addressOutside.placeOfWork"
          ></v-text-field>
          <v-text-field
            class="flex-grow-0"
            label="House No./Bldg Name"
            v-model="addressOutside.houseNo"
          ></v-text-field>
          <v-text-field class="flex-grow-0" label="Street" v-model="addressOutside.street"></v-text-field>
          <v-text-field
            class="flex-grow-0"
            label="Municipality"
            v-model="addressOutside.municipality"
          ></v-text-field>
          <v-text-field class="flex-grow-0" label="City" v-model="addressOutside.city"></v-text-field>
          <v-text-field class="flex-grow-0" label="Province" v-model="addressOutside.province"></v-text-field>
          <v-text-field class="flex-grow-0" label="Country" v-model="addressOutside.country"></v-text-field>
          <v-text-field
            class="flex-grow-0"
            label="Office Phone No"
            v-model="addressOutside.officePhoneNo"
          ></v-text-field>
          <v-text-field
            class="flex-grow-0"
            label="Cellphone No"
            v-model="addressOutside.cellPhoneNo"
          ></v-text-field>
        </div>
      </div>

      <v-btn
        color="primary"
        class="buttonText align-self-center my-10"
        width="200"
        rounded
        depressed
        type="submit"
      >Save & Proceed</v-btn>
    </v-form>

    <v-dialog v-model="dialog" width="400">
      <v-card>
        <v-card-text>
          <div class="d-flex flex-column align-center py-10">
            <h2 class="text-center black--text">You did not fill in all required fields</h2>
            <v-btn @click="dialog=false" rounded depressed color="primary" class="buttoonText mt-10">OK</v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { required, email } from "vuelidate/lib/validators";
import axios from "axios";
export default {
  data() {
    return {
      dialog: false,

      companyExists:[],
      menu: false,
      interviewDate: this.$store.state.selfService.newShippingTest?.interviewDate,
      lastName: this.$store.state.selfService.newShippingTest?.lastName,
      firstName: this.$store.state.selfService.newShippingTest?.firstName,
      passportNo: this.$store.state.selfService.newShippingTest?.passportNo,
      email: this.$store.state.selfService.newShippingTest?.email,
      caseCode: this.$store.state.selfService.newShippingTest?.caseCode,
      orgCode: this.$store.state.selfService.newShippingTest?.orgCode,

      fullAddress: this.$store.state.selfService.newShippingTest?.formJsonText?.fullAddress,

      //extra
      //patiientProfile
      patientProfile: {
        middleName: this.$store.state.selfService.newShippingTest?.formJsonText
          ?.patientProfile?.middleName,
        birthDay: this.$store.state.selfService.newShippingTest?.formJsonText
          ?.patientProfile?.birthDay,
        age: this.$store.state.selfService.newShippingTest?.formJsonText
          ?.patientProfile?.age,
        sex: this.$store.state.selfService.newShippingTest?.formJsonText
          ?.patientProfile?.sex,
        occupation: this.$store.state.selfService.newShippingTest?.formJsonText
          ?.patientProfile?.occupation,
        civilStatus: this.$store.state.selfService.newShippingTest?.formJsonText
          ?.patientProfile?.civilStatus,
        nationality: this.$store.state.selfService.newShippingTest?.formJsonText
          ?.patientProfile?.nationality
      },

      //residence
      //permanent adddress
      permanentAddress: {
        houseNo: this.$store.state.selfService.newShippingTest?.formJsonText
          ?.permanentAddress?.houseNo,
        street: this.$store.state.selfService.newShippingTest?.formJsonText
          ?.permanentAddress?.street,
        municipality: this.$store.state.selfService.newShippingTest?.formJsonText
          ?.permanentAddress?.municipality,
        city: this.$store.state.selfService.newShippingTest?.formJsonText
          ?.permanentAddress?.city,
        province: this.$store.state.selfService.newShippingTest?.formJsonText
          ?.permanentAddress?.province,
        region: this.$store.state.selfService.newShippingTest?.formJsonText
          ?.permanentAddress?.region,
        homePhoneNo: this.$store.state.selfService.newShippingTest?.formJsonText
          ?.permanentAddress?.homePhoneNo,
        cellPhoneNo: this.$store.state.selfService.newShippingTest?.formJsonText
          ?.permanentAddress?.cellPhoneNo
      },

      currentAddress: {
        houseNo: this.$store.state.selfService.newShippingTest?.formJsonText
          ?.currentAddress?.houseNo,
        street: this.$store.state.selfService.newShippingTest?.formJsonText
          ?.currentAddress?.street,
        municipality: this.$store.state.selfService.newShippingTest?.formJsonText
          ?.currentAddress?.municipality,
        city: this.$store.state.selfService.newShippingTest?.formJsonText
          ?.currentAddress?.city,
        province: this.$store.state.selfService.newShippingTest?.formJsonText
          ?.currentAddress?.province,
        region: this.$store.state.selfService.newShippingTest?.formJsonText
          ?.currentAddress?.region,
        homePhoneNo: this.$store.state.selfService.newShippingTest?.formJsonText
          ?.currentAddress?.homePhoneNo,
        workPhoneNo: this.$store.state.selfService.newShippingTest?.formJsonText
          ?.currentAddress?.workPhoneNo,
        otherEmail: this.$store.state.selfService.newShippingTest?.formJsonText
          ?.currentAddress?.otherEmail
      },

      addressOutside: {
        employersName: this.$store.state.selfService.newShippingTest?.formJsonText
          ?.addressOutside?.employersName,
        occupation: this.$store.state.selfService.newShippingTest?.formJsonText
          ?.addressOutside?.occupation,
        placeOfWork: this.$store.state.selfService.newShippingTest?.formJsonText
          ?.addressOutside?.placeOfWork,
        houseNo: this.$store.state.selfService.newShippingTest?.formJsonText
          ?.addressOutside?.houseNo,
        street: this.$store.state.selfService.newShippingTest?.formJsonText
          ?.addressOutside?.street,
        city: this.$store.state.selfService.newShippingTest?.formJsonText
          ?.addressOutside?.city,
        municipality: this.$store.state.selfService.newShippingTest?.formJsonText
          ?.addressOutside?.municipality,
        province: this.$store.state.selfService.newShippingTest?.formJsonText
          ?.addressOutside?.province,
        country: this.$store.state.selfService.newShippingTest?.formJsonText
          ?.addressOutside?.country,
        officePhoneNo: this.$store.state.selfService.newShippingTest?.formJsonText
          ?.addressOutside?.officePhoneNo,
        cellPhoneNo: this.$store.state.selfService.newShippingTest?.formJsonText
          ?.addressOutside?.cellPhoneNo
      }
    };
  },

  methods: {
    submit() {
      this.$v.$touch();
      console.log(this.$v);
      if (!this.$v.$invalid) {
        const credentials = {
          interviewDate: this.interviewDateFormat,
          caseCode: "",
          orgCode: this.orgCode,
          lastName: this.lastName,
          firstName: this.firstName,
          passportNo: this.passportNo,
          email: this.email.toLowerCase(),
          formJsonText: {
            patientProfile: this.patientProfile,
            permanentAddress: this.permanentAddress,
            currentAddress: this.currentAddress,
            addressOutside: this.addressOutside,
            fullAddress: this.fullAddress
          }
        };

        this.$store.dispatch("selfServiceNewShippingTestFirst", credentials);
      }else{
        this.dialog = true
      }
    }
  },

  validations: {
    email: { required, email },
    interviewDate: { required },
    firstName: { required },
    lastName: { required },
    passportNo: { required },
    fullAddress:{
      required
    },
    permanentAddress: {
      cellPhoneNo: {
        required
      }
    }
  },

  computed: {
    interviewDateFormat() {
      const date = new Date(this.interviewDate);
      return date.getTime();
    },
    emailErrors() {
      const errors = [];
      if (!this.$v.email.$dirty) return errors;
      if (!this.$v.email.required) errors.push("Required");
      if (!this.$v.email.email) errors.push("Invalid email");

      return errors;
    },

    fullAddressErrors(){
      const errors = []
      if (!this.$v.fullAddress.$dirty) return errors
      if (!this.$v.fullAddress.required) errors.push('Required')
      return errors
    },

    interviewDateErrors() {
      const errors = [];
      if (!this.$v.interviewDate.$dirty) return errors;
      if (!this.$v.interviewDate.required) errors.push("Required");

      return errors;
    },

    firstNameErrors() {
      const errors = [];
      if (!this.$v.firstName.$dirty) return errors;
      if (!this.$v.firstName.required) errors.push("Required");
      return errors;
    },

    lastNameErrors() {
      const errors = [];
      if (!this.$v.lastName.$dirty) return errors;
      if (!this.$v.lastName.required) errors.push("Required");
      return errors;
    },

    passportNoErrors() {
      const errors = [];
      if (!this.$v.passportNo.$dirty) return errors;
      if (!this.$v.passportNo.required) errors.push("required");
      return errors;
    },

    cellPhoneNoErrors(){
      const errors = [];
      if (!this.$v.permanentAddress.cellPhoneNo.$dirty) return errors;
      if (!this.$v.permanentAddress.cellPhoneNo.required) errors.push("required");
      return errors;
    }
  },

  watch: {
    caseCode(val) {
      if (!!val) {
        axios
          .get(`${process.env.VUE_APP_BASE_URL}/search/org/${val}`)
          .then(res => {
            console.log(res);
          })
          .catch(err => {
            console.log(err);
          });
      }
    },

    orgCode(val){
      if(!!val){
        axios.get(`${process.env.VUE_APP_BASE_URL}/org/valid/${val}`)
        .then(res => {
          console.log(res)
          if(!res.data){
            this.companyExists.push('Not valid')
          }else{
            this.companyExists = []
          }
        })
        .catch(err => {
          console.log(err)
        })
      }
    }
  }
};
</script>